app.factory("$filter_date",function(_$filter){
    
    
    return {
        
      prefilter:function(scope){
         
          return scope.model.value; 
      
      },
      getTemplate:function(){
          
          return _$filter.getPath()+"/adapters/date.html";
      }
        
    };
    
});

